var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.printValue)?_c('v-chip',{attrs:{"label":""}},[_vm._v(" "+_vm._s(_vm.printValue)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }